export { default as ic_next_chevron } from "./ic_next_chevron.svg?react";
export { default as ic_prev_chevron } from "./ic_prev_chevron.svg?react";
